import { useTranslation } from 'react-i18next';
import './video.scss';
import { motion } from 'framer-motion';
import { motionX, motionY } from 'src/core/animation';
import { useState } from 'react';
import translateSetting from 'src/core/translate-setting';

const Video = () => {
  let curLng = translateSetting.getCurrentLanguage();

  let videoLink = 'https://www.youtube.com/embed/wc9nq_HfHVM?si=SQzvhmMVQ_DdUP1R';
  if (curLng === 'ENG') {
    videoLink = 'https://www.youtube.com/embed/wc9nq_HfHVM?si=SQzvhmMVQ_DdUP1R';
  }
  if (curLng === 'JPN') {
    videoLink = 'https://www.youtube.com/embed/LwMR4a6uBJA?si=O0h8rfZDha09uJih';
  }

  const { t } = useTranslation();

  return (
    <section id="video" className="Video">
      <motion.div
        className="content-box"
        initial="offscreen"
        whileInView="onscreen"
        viewport={{ once: false, amount: 0.3 }}
        variants={motionY({
          transition: {
            type: 'tween',
            duration: 1.5,
          },
        })}
      >
        <div className="thin-text">{t('video.text-0')}</div>
        <div className="thick-text">{t('video.text-1')}</div>
        <iframe className="video" src={videoLink}></iframe>
      </motion.div>
    </section>
  );
};

export default Video;
